import React from 'react'
import { Box, Button, IcoMoon, CloseIcon } from '@usap/uicomponents'
import { TextWithTruncate } from './StyledCSS'

const Tag = ({ propValues }) => {
  const {
    children,
    onRemove,
    ...rest
  } = propValues

  return (
    <Box
      direction="row"
      align="center"
      background="#009688"
      pad={{ vertical: 'xsmall', horizontal: 'small' }}
      round="4px"
      fill={false}
      {...rest}
    >
      <TextWithTruncate line={1} size="small" margin={{ right: 'small' }}>
        {children}
      </TextWithTruncate>
      {onRemove && <IcoMoon icon={CloseIcon} size="small" color="white" />}
    </Box>
  )
}

export default function TagInput(props) {
  const {
    id,
    onRemove,
  } = props

  return onRemove ? (
    <Button
      id={`btn-${id}`}
      onClick={onRemove}
      margin={{ bottom: 'small' }}
      style={{ maxWidth: '100%' }}
    >
      <Tag propValues={props} />
    </Button>
  ) : <Tag propValues={props} />
}
